export default __webpack_public_path__ + "static/JS-efb8046f9f7aa16231d130e685cfc2de.jpg";